let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7HuII")).then(() => parcelRequire('46yCo'));